import { NavigateFunction } from "react-router-dom"
import { PATH_INFO } from "../../utils/helper"
import { clientFetch } from "../../../utils/clientFetch"
import { MEASUREMENT_REPORT_DOWNLOAD_ERROR_MESSAGE } from "../../utils/measurementReportDownloadErrorMessage"

type DownloadMeasurementReportParams = {
  sampleId: string
  sampleUrl?: string | null
  sampleImage?: string | null
  navigate: NavigateFunction
}

export async function downloadMeasurementReport({
  sampleId,
  sampleUrl,
  sampleImage,
  navigate
}: DownloadMeasurementReportParams): Promise<string | null> {
  try {
    const res = await clientFetch(`${process.env.REACT_APP_API_ENDPOINT}/apis/client/export/measurement-report`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ sample_id: sampleId, url: sampleUrl, sampleImage }),
      handleUnauthorized: true
    })

    if (res.status === 401) {
      return null
    }
    if (res.status === 403) {
      navigate(PATH_INFO.LOGIN.PATH)
      return null
    }

    if (!res.ok) {
      await res.text().catch(() => "")
      return MEASUREMENT_REPORT_DOWNLOAD_ERROR_MESSAGE
    }

    const blob = await res.blob()
    const downloadUrl = window.URL.createObjectURL(blob)
    const anchor = document.createElement("a")
    document.body.appendChild(anchor)
    anchor.href = downloadUrl
    anchor.download = "measurement_report.pdf"
    anchor.click()
    anchor.remove()
    window.URL.revokeObjectURL(downloadUrl)
    return null
  } catch (error) {
    console.error("採寸表ダウンロードに失敗しました。", error)
    return MEASUREMENT_REPORT_DOWNLOAD_ERROR_MESSAGE
  }
}
